// tslint:disable:no-any (autogenerated)
import BaseStore from '../../components/base/base-store';

export interface ICustomizationStoreState {
    styles: any;
    loaded?: boolean;
}

class CustomizationStore extends BaseStore<ICustomizationStoreState> {
    public dispatcherEvents: string = 'setCustomizationStoreState';

    public initialState: any = {
        styles: {},
        loaded: false
    };

    constructor() {
        super();
        this.initialize('CustomizationStore');
    }

    // tslint:disable-next-line:member-access (autogenerated)
    getStyles(immediate: boolean = false): any {
        return (immediate ? this.getImmediateState() : this.getState()).styles;
    }
}

const store = new CustomizationStore();
// tslint:disable-next-line:no-default-export (autogenerated)
export default store;
